/** Upload metadata helpers for photo/video socket uploads. */

export const MEDIA_UPLOAD_TIMEOUT_MS = 120000;

export const formatUploadFileMeta = (file) => {
  if (!file) {
    return { name: null, type: null, sizeBytes: null, sizeMb: null };
  }
  const sizeBytes = file.size ?? file._rawFileSize ?? null;
  return {
    name: file.name ?? null,
    type: file.type ?? file.mime ?? null,
    sizeBytes,
    sizeMb: sizeBytes != null ? Number((sizeBytes / (1024 * 1024)).toFixed(2)) : null,
  };
};

export const shouldLogMediaUpload = (fileType, file) => {
  if (fileType === "image" || fileType === "video") return true;
  const mime = String(file?.type || file?.mime || "").toLowerCase();
  if (mime.startsWith("image/") || mime.startsWith("video/")) return true;
  const name = String(file?.name || file?.fileName || "").toLowerCase();
  return /\.(jpe?g|png|gif|webp|bmp|svg|mp4|webm|mov|avi|mkv|ogg)$/i.test(name);
};

export const summarizeSocketPayload = (payload = {}) => {
  const { file, token, ...rest } = payload;
  return {
    ...rest,
    tokenPresent: Boolean(token),
    fileByteLength: file?.byteLength ?? file?.length ?? null,
  };
};

/**
 * @param {"1-on-1"|"group"} context
 * @param {string} phase
 * @param {File|object|null} file
 * @param {object} details
 */
export const logMediaUpload = (context, phase, file, details = {}) => {
  const entry = {
    timestamp: new Date().toISOString(),
    context,
    phase,
    file: formatUploadFileMeta(file),
    ...details,
  };
  return entry;
};
